<template>
  <div class="_newinfo globalnews">
    <div class="_newinfo-inner">
      <h2 class="_newinfo-ttl">
        管理会社より
        <div class="-more">
          <router-link
            class="-more-link"
            :to="{
              name: 'information-1',
              params: { mc_code: mcCode },
            }"
            ><img src="/i-salon/assets/img/main/ic-more.png" alt="MORE"
          /></router-link>
        </div>
      </h2>
      <div class="_newinfo-list" v-if="news.length > 0">
        <!-- whats new start -->
        <p
          class="_newinfo-item -mq"
          v-for="(item, index) in news"
          :key="index"
          v-show="item.is_top"
        >
          <router-link
            class="-more-link"
            :to="{
              name: 'global-information-detail',
              params: { mc_code: mcCode, id: item._id },
            }"
          >
            {{ item.registration_at | moment("YYYY.MM.DD") }}
            <span
              class="tag"
              :class="{
                tag01: item.label == 'tag01',
                tag02: item.label == 'tag02',
                tag03: item.label == 'tag03',
                tag04: item.label == 'tag04',
                tag05: item.label == 'tag05',
                tag06: item.label == 'tag06',
                tag07: item.label == 'tag07',
                tag08: item.label == 'tag08',
                tag09: item.label == 'tag09',
              }"
              >{{ statusText(item.label) }}</span
            >
            {{ item.title }}
          </router-link>
        </p>
        <!-- whats new end -->

        <!-- / _newinfo-item -->
      </div>
      <div class="_newinfo-list" v-else>
        <p>現在、管理会社からのお知らせはありません。</p>
      </div>
      <!-- / _newinfo-list -->
    </div>
    <!-- / _newinfo-inner -->
  </div>
</template>

<script>
import GlobalInfoService from "../services/global-info.service";

export default {
  name: "InfoList",
  props: ["mode"],
  data: function() {
    return {
      news: [],
    };
  },
  async mounted() {
    // console.log("list --");
    // console.log(response.data.docs);
    await this.$nextTick();
    await this.$nextTick();
    const response = await GlobalInfoService.findSchedule();
    console.log("mounted", response);
    if (response.length > 0) {
      this.news = response;
    } else {
      this.news = [];
    }
  },
  methods: {},
};
</script>

<style></style>
